import { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileArrowDown,
  faSpinner,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

function ExcelReport({ id, selectedReport }) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    if (!selectedReport) return;

    setIsExporting(true);

    try {
      const presentationId = id || "N/A";

      const uniqueSpeakers = [
        ...new Map(selectedReport?.speakers?.map((s) => [s.name, s])).values(),
      ];

      const speakerNames =
        uniqueSpeakers.map((s) => s.name).join(", ") || "N/A";

      const uniqueCities = [
        ...new Set(selectedReport?.speakers?.map((s) => s.city)),
      ];

      const cities = uniqueCities.join(", ") || "N/A";

      const creationDate = selectedReport?.speakers?.[0]?.date || "N/A";

      const flatData = [];

      selectedReport.questions.forEach((q, qIdx) => {
        const totalChoices = q?.choices?.length || 0;

        q.choices?.forEach((choice, cIdx) => {
          selectedReport.speakers.forEach((speaker, sIdx) => {
            flatData.push({
              Question: q.title,
              Choice: choice.label,
              "Responses Count": choice.count,
              Speaker: speaker.name,
              City: speaker.city,
              "Presentation Date": speaker.date || "No Date",
            });
          });
        });
      });

      // Worksheet
      const ws = XLSX.utils.json_to_sheet(flatData);

      // Workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      // Export
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, `report_${presentationId}.xlsx`);
    } catch (error) {
      console.error("Export error:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex justify-end">
      <button
        onClick={handleExport}
        disabled={isExporting}
        className={`bg-green-600 text-white text-sm rounded-lg p-2 hover:bg-green-700 uppercase flex items-center ${
          isExporting ? "opacity-75 cursor-not-allowed" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={isExporting ? faSpinner : faFileArrowDown}
          className={`mr-1 ${isExporting ? "animate-spin" : ""}`}
        />
        {isExporting ? "Exporting..." : "Export Excel"}
      </button>
    </div>
  );
}

export default ExcelReport;
